import { useMemo } from 'react'

export function usePromise<T>() {
  type PromiseResolve = (value: T | PromiseLike<T>) => void
  type PromiseReject = (reason?: unknown) => void

  const { promise, resolve, reject } = useMemo(() => {
    let resolve: PromiseResolve | undefined
    let reject: PromiseReject | undefined

    const promise = new Promise<T>((res, rej) => {
      resolve = res
      reject = rej
    })

    if (!resolve || !reject) {
      // Promise constructor body is sync and both will always have values
      // throwing only for type guard to remove undefined from types
      throw new Error('unreachable code')
    }

    return { promise, resolve, reject }
  }, [])

  return { promise, resolve, reject }
}
